import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { PrimeNGConfig } from 'tn-custom-primeng/api';
import { CoreConfigService } from 'tnx-shared';


@Component({
    selector: 'app-component',
    template: '<router-outlet></router-outlet>', // '<common-app-component></common-app-component>',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    activeTopbarItem: any;
    topbarItemClick: boolean;

    constructor(
        private _oauthService: OAuthService,
        private _coreConfigService: CoreConfigService,
        private config: PrimeNGConfig,
        private translateService: TranslateService
    ) {
        const cfg = this.getConfigAuthen();
        this.injectConfig(cfg);
        this._oauthService.setStorage(localStorage);
    }

    ngOnInit() {
        this.config.setTranslation({
            "dayNames": ["Chủ nhật", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"],
            "dayNamesShort": ["CN", "Th2", "Th3", "Th4", "Th5", "Th6", "Th7"],
            "dayNamesMin": ["CN", "Th2", "Th3", "Th4", "Th5", "Th6", "Th7"],
            "monthNames": [
                "Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"
            ],
            "monthNamesShort": ["T1", "T2", "T3", "T4", "T5", "T6", "T7", "T8", "T9", "T10", "T11", "T12"],
            "today": "Hôm nay",
        });

        this.translateService.setDefaultLang('vn');
        this.translateService.use('vn');
    }

    translate(lang: string) {
        this.translateService.use(lang);
        this.translateService.get('primeng').subscribe(res => this.config.setTranslation(res));
    }

    private injectConfig(cfg: AuthConfig) {
        this._oauthService.configure(cfg);
    }

    private getConfigAuthen() {
        const cfg = this._coreConfigService.getAuthConfig();
        cfg.responseType = 'code';
        return cfg;

    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        event.preventDefault();
    }
}
